export default __webpack_public_path__ + "static/media/cook.eacd7d43.svg";